import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import ROUTES from "../../../../utilities/Routes";

import Stage from "../../../../components/Stage";
import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import ReactLoading from "react-loading";

import { scrollToInput } from "../../../../utilities/utils";
import { isOnlyNumbers } from "../../../../utilities/Validations";

import {
    setNombreAction,
    setApellidoPaternoAction,
    setTelefonoAction,
    setMovilAction,
    setCorreoAction,
    setComentariosAction,
    setAvisosDePrivacidadAction,
    setTerminosCondicionesAction,
    reiniciarStateAction,
} from "../../../../actions/contactoActions";

import {
    validarApellidoPaterno,
    validarCelular,
    validarCorreo,
    validarNombre,
    validarTelefono,
} from "../../../../utilities/Validations/lead";
import {
    sendMailDrivingExperienceCliente,
    sendMailDrivingExperienceConcesionaria,
} from "../../../../API/ContactoRequest";
import { sendLeadToSaas } from "../../../../API/SaasRequest";

// Desactivado temporalmente: no se requiere mostrar la imagen del stage en este formulario.
const SHOW_STAGE = false;

const FormularioDrivingExperience = () => {
    const dispatch = useDispatch();
    const objSubmit = useSelector((state) => state.contacto);

    let navigate = useNavigate();

    const setNombre = (inNombre) => {
        dispatch(setNombreAction(inNombre));
    };
    const setApellidoPaterno = (inApellidoPaterno) => {
        dispatch(setApellidoPaternoAction(inApellidoPaterno));
    };
    const setTelefono = (inTelefono) => {
        dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
    };
    const setMovil = (inMovil) => {
        dispatch(setMovilAction(isOnlyNumbers(inMovil)));
    };
    const setCorreo = (inCorreo) => {
        dispatch(setCorreoAction(inCorreo));
    };
    const setComentarios = (inComentarios) => {
        dispatch(setComentariosAction(inComentarios));
    };
    const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
        dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
    };
    const setTerminosCondiciones = (inTerminosCondiciones) => {
        dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
    };

    const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [showErrorSubmit, setShowErrorSubmit] = useState(false);

    useEffect(() => {
        document.title = "Audi Driving Experience - Contacto";
    }, []);

    useEffect(() => {
        if (process.env.REACT_APP_ENABLE_GA4 === "true" && process.env.REACT_APP_DRIVING_EXPERIENCE_GA_ID) {
            ReactGA.initialize(process.env.REACT_APP_DRIVING_EXPERIENCE_GA_ID);
        }
    }, []);

    const validateForm = () => {
        if (validarNombre(objSubmit.nombre) === false) {
            scrollToInput("nombre", "Por favor ingresa un nombre válido");
            return false;
        }
        if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
            scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarTelefono(objSubmit.telefono) === false) {
            scrollToInput("telefono", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCelular(objSubmit.celular) === false) {
            scrollToInput("movil", "Por favor ingresa un valor válido");
            return false;
        }
        if (validarCorreo(objSubmit.email) === false) {
            scrollToInput("correo", "Por favor ingresa un valor válido");
            return false;
        }
        if (objSubmit.avisoPrivacidad === false || objSubmit.terminosCondiciones === false) {
            setErrorDeclaraciones(true);
            return false;
        } else {
            setErrorDeclaraciones(false);
        }

        return true;
    };

    const handleSendLeadToSaas = (lead, idTransaccion, status, model, message) => {
        sendLeadToSaas(lead, process.env.REACT_APP_FORM_ID_DRIVING_EXPERIENCE, idTransaccion, status, model, message)
            .then(() => { })
            .catch((error) => {
                console.error("Error en log: " + error);
            });
    };

    const onSubmit = (e) => {
        e.preventDefault();

        const dataIsvalid = validateForm();

        if (dataIsvalid) {
            setLoadingSubmit(true);
            setShowErrorSubmit(false);
            const lead = { ...objSubmit };
            delete lead.nombreDelVehiculo;

            const contactos = [process.env.REACT_APP_DRIVING_EXPERIENCE_CORREO_TO];
            lead.descripcion = lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim();

            sendMailDrivingExperienceCliente({
                ...lead,
                asunto: process.env.REACT_APP_DRIVING_EXPERIENCE_ASUNTO,
                imgName: process.env.REACT_APP_DRIVING_EXPERIENCE_MAIL_IMAGE,
            })
                .then(() => {
                    sendMailDrivingExperienceConcesionaria({ ...lead, contactos });
                    setLoadingSubmit(false);
                    dispatch(reiniciarStateAction());

                    lead.descripcion = `Audi Driving Experience - ${lead.descripcion}`;	// Se agrega el asunto al inicio de la descripción

                    const leadForSaas = { ...lead };
                    delete leadForSaas.avisoPrivacidad;
                    delete leadForSaas.terminosCondiciones;
                    handleSendLeadToSaas(leadForSaas, null, true, "Audi Driving Experience", "Lead enviado correctamente");

                    navigate(ROUTES.DRIVINGEXPERIENCEGENERAL + ROUTES.DRIVINGEXPERIENCETHANKYOUEMPTY);
                })
                .catch((error) => {
                    lead.descripcion = `Audi Driving Experience - ${lead.descripcion}`;	// Se agrega el asunto al inicio de la descripción
                    handleSendLeadToSaas(lead, null, false, "Audi Driving Experience", error?.response?.data?.message || error?.message || "Error en envío de lead");
                    setLoadingSubmit(false);
                    setShowErrorSubmit(true);
                    console.log("ERROR: ", error);
                });
        }
    };

    return (
        <main className="audi-nuevo">
            {SHOW_STAGE && (
                <Stage
                    title="Audi Driving Experience"
                    img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + process.env.REACT_APP_DRIVING_EXPERIENCE_STAGE_IMAGE}
                />
            )}
            <div className="container mt-4 mb-5 w-100">
                <ButtonBack />
            </div>
            <section className="container w-100 pt-3">
                <p className="mb-5">
                    Por favor completa el siguiente formulario. Nos pondremos en contacto contigo para resolver tus dudas y brindarte la información que necesitas.
                </p>
                <form className="w-100 pt-5" onSubmit={onSubmit}>
                    <h3>Datos de contacto</h3>
                    <div className="fields-grid mt-4 mb-5">
                        <div className="order-1">
                            <InputText
                                label="¿Cuál es tu nombre?"
                                name="nombre"
                                maxLength={40}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    e.target.value = value;
                                    setNombre(value);
                                }}
                                errorMessage="Carácter no válido, por favor use solo letras."
                                validator={validarNombre}
                            />
                        </div>
                        <div className="order-2">
                            <InputText
                                label="¿Cuál es tu apellido?"
                                name="apellidoPaterno"
                                maxLength={80}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    e.target.value = value;
                                    setApellidoPaterno(value);
                                }}
                                errorMessage="Carácter no válido, por favor use solo letras."
                                validator={validarApellidoPaterno}
                            />
                        </div>
                        <div className="order-3">
                            <InputText
                                label="¿Cuál es tu número de teléfono?"
                                name="telefono"
                                value={objSubmit.telefono}
                                maxLength={10}
                                onChange={(e) => {
                                    if (e.target.value.length <= 10)
                                        setTelefono(e.target.value);
                                }}
                                errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                validator={validarTelefono}
                            />
                        </div>
                        <div className="order-4">
                            <InputText
                                label="¿Cuál es tu número móvil?"
                                name="movil"
                                value={objSubmit.celular}
                                maxLength={10}
                                onChange={(e) => {
                                    if (e.target.value.length <= 10)
                                        setMovil(e.target.value);
                                }}
                                errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                validator={validarCelular}
                            />
                        </div>
                        <div className="order-5">
                            <InputText
                                label="¿Cuál es tu e-mail?"
                                name="correo"
                                value={objSubmit.email}
                                maxLength={80}
                                onChange={(e) => {
                                    if (e.target.value.length <= 80)
                                        setCorreo(e.target.value);
                                }}
                                errorMessage="Por favor use un e-mail válido con formato: nombre@dominio.com"
                                validator={validarCorreo}
                            />
                        </div>
                    </div>

                    <div className="">
                        <InputTextArea
                            name="comentarios"
                            placeholder="Mensaje"
                            errorMessage="Tu comentario excede los 1,000 caracteres"
                            maxLength={1000}
                            onChange={(e) => {
                                const value = e.target.value.trim();
                                if (value.length <= 1000)
                                    setComentarios(value);
                            }}
                            isValid={true}
                        />
                    </div>

                    <div className="mt-5 pt-5">
                        <h3>Estamos comprometidos con tu privacidad</h3>
                        <p className="mt-4 pb-5">
                            En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
                        </p>

                        <div className="d-flex flex-column gap-3">
                            <InputCheckBox
                                rounded
                                label="Aceptar todo"
                                onChange={(e) => {
                                    var checkboxes = document.getElementsByName("checkboxgroup");

                                    checkboxes.forEach((cbx) => {
                                        cbx.checked = e.target.checked;
                                    });
                                    setAvisosDePrivacidad(e.target.checked);
                                    setTerminosCondiciones(e.target.checked);
                                }}
                            />

                            <InputCheckBox
                                name="checkboxgroup"
                                onChange={(e) => {
                                    setAvisosDePrivacidad(e.target.checked);
                                }}
                            >
                                <span>
                                    He leído y acepto el{" "}
                                    <a
                                        href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Aviso de Privacidad.
                                    </a>
                                </span>
                            </InputCheckBox>
                            <InputCheckBox
                                name="checkboxgroup"
                                onChange={(e) => {
                                    setTerminosCondiciones(e.target.checked);
                                }}
                            >
                                <span>
                                    He leído y acepto el{" "}
                                    <a
                                        href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Términos y Condiciones.
                                    </a>
                                </span>
                            </InputCheckBox>

                            <span
                                className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"}`}
                            >
                                Para continuar, acepta nuestras declaraciones de conformidad.
                            </span>
                        </div>
                    </div>
                    <div>
                        {!loadingSubmit ? (
                            <button className={`button-enviar`} type="submit">
                                Enviar
                            </button>
                        ) : (
                            <button className="button-enviar disabled" type="button" disabled={true}>
                                <div className="loading-g loading-send loading-btn">
                                    <div>
                                        <ReactLoading type="cylon" color="#fff" width={"100%"} height={"58px"} />
                                    </div>
                                </div>
                            </button>
                        )}
                    </div>
                    <span className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""}`}>
                        Hubo un error. Por favor, Intentelo más tarde.
                    </span>
                </form>
            </section>
        </main>
    );
};

export default FormularioDrivingExperience;
